// extracted by mini-css-extract-plugin
module.exports = {"payment-iframe":"styles-module__payment-iframe___15kqX"};